function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M40,88.6s13.3-15.6,30.3-15.6,12.8.4,12.8.4c0,0,5.3.9,11.4,2,6.5,1.9,33.5,10,37.5,13.2,3.5,2.7,2.8,7.3,1.4,9-6,6-13.3.5-19.5-1.8-4.8-1.7-33.6-11-41.1-12-7.5-1-9.9-1.7-16.9,0-7,1.7-15.7,4.8-15.7,4.8Z"
});

var SvgIcoSimulationCategoryBrows = function SvgIcoSimulationCategoryBrows(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 174 174",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoSimulationCategoryBrows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_simulation_category_brows.1d47df6d.svg";
export { ForwardRef as ReactComponent };